import React from "react";
import { FaFacebookSquare } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-container">

        <div className="footer-brand">

          <h2>
            Margaret Robi Foundation
          </h2>

          <p>
            Empowering girls and young women by restoring dignity, creating opportunity, and helping 
            them thrive where conflict, harmful cultural practices, and inequality shape everyday life.
          </p>

          <div className="footer-social">

            <a href="https://www.facebook.com/share/18yUpuGDjq/?mibextid=wwXIfrm" target="_blank" rel="noreferrer">
              <FaFacebookSquare />
            </a>

            <a href="https://x.com/MargaretRobiFdn" target="_blank" rel="noreferrer">
              <FaXTwitter />
            </a>

             <a href="https://www.instagram.com/margaret_robi_foundation?igsh=enBmanQxN3M5ZjVh&utm_source=qr" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
             </a>

            <a href="https://www.linkedin.com/company/margaret-robi-foundation/" target="_blank" rel="noreferrer">
              <FaLinkedin />
            </a>

          </div>

        </div>



        <div className="footer-section">

          <h4>About Us</h4>

          <ul>
            <li><a href="/about">Our Story</a></li>
            <li><a href="/need">The Need</a></li>
            <li><a href="/partners">Partners</a></li>
            <li><a href="/inspiration">Inspiration</a></li>
          </ul>

        </div>



        <div className="footer-section">

          <h4>Our Impact</h4>

          <ul>
            <li><a href="/volunteer">Volunteer</a></li>
            <li><a href="/partners">Partner</a></li>
            <li><a href="/donate">Donate</a></li>
            {/* <li><a href="/journey">Stories</a></li> */}
          </ul>

        </div>



        <div className="footer-section">

          <h4>Contact</h4>

          <p>Email:</p>
          <span>
            info@margaretrobifoundation.org
          </span>


          <p>Phone:</p>
          <span>
            +254 727761064
          </span>


          {/* <button>
            <a href="/donate">Donate Now</a>
          </button> */}


        </div>


      </div>



      <div className="footer-bottom">

        <p>
          © 2026 Margaret Robi Foundation. All Rights Reserved.
        </p>

      </div>


    </footer>
  );
};


export default Footer;